export default {
  methods: {
    async leaveRoute(to, from, next) {
      // only validate when moving forward in flow
      if (to.path.length < from.path.length) {
       return next();
      }

      const result = await this.$parent.$parent.$parent.validate();

      if (result.valid) {
        next();
      }
    }
  }
};
